import React from 'react';
import { Grid } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { PasslyCheckbox } from '@app/components';
import { IDomainResult } from '@app/models';

import {
    DomainResults,
    GraphApiConfig,
    ManualGraphConfig
} from '@app/components/SSOApps/addEditAppTabs/appMsol';
import { IOffice365State } from '@app/components/SSOApps/addEditAppTabs';
import { MODULE_NAME } from '@app/pages/ssoManager/addEditApplication.enums';

interface IProps {
    state: IOffice365State;
    setState: Function;
    handleOnDisconnect: (module: string) => () => void;
    updateManagedSetup: (name: string, value: unknown) => void;
    verifyCredentials: (module: string) => () => void;
    connected: boolean;
}

export const AppGraphApiFederation = ({ state, setState, handleOnDisconnect, updateManagedSetup, verifyCredentials, connected }: IProps) => {
    const { translation } = useTypedTranslation();

    const handleCheckboxChange = (checked: boolean, event: any) => {
        updateManagedSetup(event.target.name, checked);
    };

    return (
        <>
            <Grid container direction='row'>
                <Grid item md={5}>
                    <GraphApiConfig
                        setManagedConfig={updateManagedSetup}
                        officeConfig={state}
                        setState={setState}
                        verifyCredentials={verifyCredentials(MODULE_NAME.graphModule)}
                        isGraph={true}
                    />
                </Grid>
                <Grid item md={7}>
                    <ul className='domain-results'>
                        {state.managedSetup.domainResults.map((result: IDomainResult, index: number) => (
                            <DomainResults result={result} index={index} key={index} />
                        ))}
                    </ul>
                </Grid>
            </Grid>

            <PasslyCheckbox
                name='active'
                className='msol__manage-checkbox'
                checked={state.managedSetup.active}
                onChange={handleCheckboxChange}
                label={translation('MSOL_MANAGED_SERVICE')}
            />

            {!state.managedSetup.active ? <ManualGraphConfig onDisconnect={handleOnDisconnect(MODULE_NAME.graphModule)} connected={connected} domain={state.managedSetup.domainGraphModule} /> : null}
        </>
    );
};
